import { getRegion, Region } from '~/src/regions/config/utils';
import type { TemplateMetadata } from '~/src/hooks/useGetTemplateMetadata';

export interface AdditionalRegionInfo {
  region: string;
  label: string;
}

export const getFilterCategoriesForRegion = (
  metadata: TemplateMetadata,
  region: string,
): string[] => {
  const regionMap = metadata.region_map || {};
  return Object.keys(metadata.filter_categories || {}).filter(
    (category) => regionMap[category] === region,
  );
};

const REGION_LABEL: Record<string, string> = {
  [Region.CA]: 'Canada Forms',
  [Region.AU]: 'Australia Forms',
};

/**
 * Maps backend region codes to display info, filtering out the current app region.
 */
export const getAdditionalRegionForms = (
  regions?: string[],
): AdditionalRegionInfo[] => {
  if (!regions?.length) return [];
  const currentRegion = getRegion();
  return regions
    .filter((r) => r !== currentRegion)
    .map((r) => ({ region: r, label: REGION_LABEL[r] || `${r} Forms` }));
};

export const ADDITIONAL_REGION_FORMS_ROUTE_SEGMENT = '/additional-region-forms';

export type SubFilterType = 'practice_area' | 'county';

const REGION_SUB_FILTER_TYPE: Record<string, SubFilterType> = {
  [Region.CA]: 'county',
};

export const getSubFilterType = (region?: string): SubFilterType =>
  (region && REGION_SUB_FILTER_TYPE[region]) || 'practice_area';

export const usesCountySubFilter = (region?: string): boolean =>
  getSubFilterType(region) === 'county';

const REGION_SUB_FILTER_LABEL: Record<string, string> = {
  [Region.US]: 'County',
  [Region.EU]: 'Practice Areas',
  [Region.AU]: 'Practice Areas',
  [Region.CA]: '',
};

export const getSubFilterLabel = (region?: string): string =>
  region && region in REGION_SUB_FILTER_LABEL
    ? REGION_SUB_FILTER_LABEL[region] ?? 'Practice Areas'
    : 'Practice Areas';
